var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['regular-button', _vm.color]},[_c('span',[_vm._v(_vm._s(_vm.caption))])])}
var staticRenderFns = []

export { render, staticRenderFns }